import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import Typography from '@digital-hig/mui/dist/Typography';

const PDFViewer = ({ data }) => (
  <RootElement>
    <Grid container>
      <Grid item lg={8} md={12} sm={12}>
        <Typography variant="headline-medium" className="title">{data.text}</Typography>
        <object data={data.url} type="application/pdf">
          <Typography variant="body-copy-medium">
            It appears you don&apos;t have a PDF plugin for this browser.
          </Typography>
        </object>
      </Grid>
    </Grid>
  </RootElement>
);

const RootElement = styled.div`
  object {
    width: 100%;
    height: 600px;
  }
  .title{
    padding-bottom:26px;
  }
  @media screen and (max-width: 600px){
    object {
      height: 300px;
    }
  }
`;

PDFViewer.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default PDFViewer;
